import { useTranslation } from 'react-i18next'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { tomorrow, coy } from 'react-syntax-highlighter/dist/esm/styles/prism'
import JsonView from '@uiw/react-json-view'
import { lightTheme } from '@uiw/react-json-view/light'
import { darkTheme } from '@uiw/react-json-view/dark'
import type { TextRendererProps } from '../types'

export function JsonRenderer({ content, isDarkTheme, wordWrap, showLineNumbers }: TextRendererProps) {
  const { t } = useTranslation()
  const syntaxTheme = isDarkTheme ? tomorrow : coy

  const codeStyle = {
    margin: 0,
    borderRadius: '8px',
    fontSize: '14px',
    backgroundColor: 'transparent',
    padding: '16px',
    border: 'none',
  }

  try {
    const jsonData = JSON.parse(content)
    return (
      <div className="flex-1 min-h-0 flex flex-col rounded-lg border overflow-hidden" style={{ backgroundColor: 'var(--sidebar-background)', borderColor: 'var(--sidebar-border)' }}>
        <div className="file-preview-content flex-1 overflow-auto">
          <div className="p-4">
            <div className={`file-preview-json ${isDarkTheme ? 'json-dark' : 'json-light'}`}>
              <JsonView
                value={jsonData}
                style={{
                  ...(isDarkTheme ? darkTheme : lightTheme),
                  backgroundColor: 'transparent',
                  fontSize: '14px',
                  fontFamily: 'monospace',
                }}
                displayDataTypes={true}
                displayObjectSize={true}
                enableClipboard={true}
                collapsed={2}
              />
            </div>
          </div>
        </div>
      </div>
    )
  } catch {
    return (
      <div className="flex-1 min-h-0 flex flex-col rounded-lg border overflow-hidden" style={{ backgroundColor: 'var(--sidebar-background)', borderColor: 'var(--sidebar-border)' }}>
        <div className="file-preview-content flex-1 overflow-auto">
          <div className="p-4">
            <div className="mb-4 p-3 bg-red-500/10 text-red-600 dark:text-red-400 rounded-lg border border-red-500/30">
              {t('filePreview.invalidJson')}
            </div>
            <SyntaxHighlighter
              language="json"
              style={syntaxTheme}
              showLineNumbers={showLineNumbers}
              wrapLines={wordWrap}
              wrapLongLines={wordWrap}
              customStyle={codeStyle}
              PreTag="div"
            >
              {content}
            </SyntaxHighlighter>
          </div>
        </div>
      </div>
    )
  }
}
